import { format } from 'date-fns'
import { Link } from 'react-router-dom'
import { ArrowRight, Camera, ShoppingBag } from 'lucide-react'
import { shopSetupProgress } from '@adthlete/shared-frontend'
import { useGetMyMarketplaceProfileQuery } from '@/redux/collaborationsApi'
import HomeFeed from '@/components/dashboard/HomeFeed'
import HomeCtas from '@/components/dashboard/HomeCtas'
import { useAuth } from '@/hooks/useAuth'

const Dashboard = () => {
  const { athlete } = useAuth()
  const todayLabel = format(new Date(), 'EEEE, MMMM d')
  const firstName = athlete?.name?.split(' ')[0] ?? ''
  const { data: shop } = useGetMyMarketplaceProfileQuery()
  const setup = shop ? shopSetupProgress(shop) : null

  return (
    <div className="pb-8 max-w-lg mx-auto">
      <div className="mb-5">
        <h1 className="text-2xl font-bold text-foreground">
          {firstName ? `Hey ${firstName}` : 'Hey'}
        </h1>
        <p className="text-gray-500 text-sm">{todayLabel}</p>
      </div>
      {/* At a Lab school, until the shop is open, the first month with the Lab leads */}
      {athlete?.school?.creatorLab && setup && !setup.ready ? (
        <Link
          to="/welcome"
          className="mb-5 flex items-center justify-between gap-3 rounded-2xl border border-[#C0FD72] bg-[#C0FD72]/15 px-4 py-3"
        >
          <span className="min-w-0 flex-1">
            <span className="flex items-center gap-2 font-bold text-foreground">
              <Camera className="h-4 w-4 text-[#4d7c0f]" /> Your first month with the Athios Lab
            </span>
            <span className="block text-xs text-gray-600">
              Strategy call, shoot days, your content calendar and your Content Shop
            </span>
          </span>
          <ArrowRight className="h-4 w-4 shrink-0 text-gray-600" />
        </Link>
      ) : null}
      {/* The calendar and the Academy have no tab of their own, so Home leads with them */}
      <HomeCtas />
      <Link
        to="/brand-view"
        className="mb-5 flex items-center justify-between gap-3 rounded-2xl border border-foreground/10 bg-card px-4 py-3 hover:bg-foreground/10 shadow-[0_1px_2px_rgba(30,41,59,0.04)]"
      >
        <span className="min-w-0 flex-1">
          <span className="flex items-center gap-2 font-bold text-foreground">
            <ShoppingBag className="h-4 w-4 text-[#4d7c0f]" /> Your Content Shop
          </span>
          <span className="block text-xs text-gray-600">
            {setup && !setup.ready
              ? `${setup.done} of ${setup.total} set up. Finish it so brands can book you`
              : 'Open, and ready to book. See it the way brands do'}
          </span>
          {setup && !setup.ready ? (
            <span className="mt-2 block h-1.5 overflow-hidden rounded-full bg-muted">
              <span
                className="block h-full rounded-full bg-[#C0FD72]"
                style={{ width: `${(setup.done / setup.total) * 100}%` }}
              />
            </span>
          ) : null}
        </span>
        <ArrowRight className="h-4 w-4 shrink-0 text-gray-600" />
      </Link>
      <HomeFeed />
    </div>
  )
}

export default Dashboard
